import React from 'react'
import { MaterialSymbolProps } from './types'

export const StyledMaterialSymbol: React.FC<MaterialSymbolProps> = ({ name, className, style, size, onClick }) => {
  const classes=['material-symbols-outlined', className].filter(Boolean).join(' ')
  const combinedStyle = size ? { ...style, fontSize: size } : style

  return (
    <span className={classes} style={combinedStyle} onClick={onClick}>{name}</span>
  )
}
